import { MultiValue } from "react-select";
import { CollectorInfo, RouteCollectionInfo, RouteState } from "./state";
import { BinInfo } from "../staticInfo/state";



export function initCollectorAction(collectorList:CollectorInfo[]){
    return {
        type: '@@RouteState/initCollectorAction' as const ,
        collectorList
    }

}

export function SelectBinInfosAction(selectedBinInfo:MultiValue<BinInfo> ){
    return {
        type: '@@RouteState/SelectBinInfosAction' as const ,
        selectedBinInfo
    }
}

export function ChangeRouteNameAction(route_name:string){
    return {
        type: '@@RouteState/ChangeRouteName' as const ,
        route_name
    }
}

export function ChangeCollectorAction(collector_id:string){
    return {
        type: '@@RouteState/ChangeCollectorAction' as const ,
        collector_id
    }
}

export function ChangeRouteRemark(remark:string){
    return {
        type: '@@RouteState/ChangeRouteRemark' as const ,
        remark
    }
}

export function ChangeWorkingDate(weekday:string){
    return {
        type: '@@RouteState/ChangeWorkingDate' as const ,
        weekday
    }
}

export function ChangeEffectiveDateAction(date:Date){
    return {
        type: '@@RouteState/ChangeEffectiveDateAction' as const ,
        date
    }
}

export function ClearRouteFormDataAction(){
    return {
        type: '@@RouteState/ClearRouteFormDataAction' as const ,
        
    }
} 

export function initRouteListAction(routeList: RouteState[]){
    return {
        type: '@@RouteState/initRouteListAction' as const ,
        routeList      
    }
} 

export function GetDataFromRouteListAction(routeData:RouteState,routeList:MultiValue<BinInfo>){
    return {
        type: '@@RouteState/GetDataFromRouteListAction' as const ,
        routeData,
        routeList      
    }
}

export function initCollectRouteListAction( RouteCollectionList:RouteCollectionInfo[]){
    return {
        type: '@@RouteState/initCollectRouteListAction' as const ,
        RouteCollectionList   
    }
}

export function ChangeRouteTimeStartTimeAction(start_time:string,index:number){
    return {
        type: '@@RouteState/ChangeRouteTimeStartTimeAction' as const ,
        start_time,
        index   
    }
}

export function ChangeRouteTimeEndTimeAction(end_time:string,index:number){
    return {
        type: '@@RouteState/ChangeRouteTimeEndTimeAction' as const ,
        end_time,
        index   
    }
}




export type RouteAction =

|ReturnType<typeof initCollectorAction>
|ReturnType<typeof SelectBinInfosAction>
|ReturnType<typeof ChangeRouteNameAction>
|ReturnType<typeof ChangeCollectorAction>
|ReturnType<typeof ChangeWorkingDate>
|ReturnType<typeof ChangeRouteRemark>
|ReturnType<typeof ChangeEffectiveDateAction>
|ReturnType<typeof ClearRouteFormDataAction>
|ReturnType<typeof initRouteListAction>
|ReturnType<typeof GetDataFromRouteListAction>
|ReturnType<typeof initCollectRouteListAction>
|ReturnType<typeof ChangeRouteTimeStartTimeAction>
|ReturnType<typeof ChangeRouteTimeEndTimeAction>